import { put, takeEvery } from "redux-saga/effects"
import { get, post } from "helpers/api_helper"
import {
  getCalendarEventFeatureFailed,
  getCalendarEventFeatureSuccess,
  getCalendarEventsFailed,
  getCalendarEventsSuccess,
  getCalendarReportsFailed,
  getCalendarReportsSuccess,
  updateCalendarEventsFailed,
  updateCalendarEventsSuccess,
} from "./actions"
import { showSavingModal, hideSavingModal } from "../actions"
import {
  GET_CALENDAR_EVENTS,
  GET_CALENDAR_EVENT_FEATURE,
  GET_CALENDAR_REPORTS,
  UPDATE_CALENDAR_EVENTS,
} from "./actionTypes"

function* getCalendarEvents({ payload: params }) {
  try {
    const response = yield get("/calendar", { params })
    yield put(getCalendarEventsSuccess(response))
  } catch (error) {
    yield put(getCalendarEventsFailed(error))
  }
}

function* getCalendarEventsFeature({ payload: params }) {
  try {
    const response = yield get("/admin/calendar/menu-item", { params })
    yield put(getCalendarEventFeatureSuccess(response))
  } catch (error) {
    yield put(getCalendarEventFeatureFailed(error))
  }
}

function* updateCalendarEvents({ payload: params }) {
  try {
    yield put(showSavingModal())
    const response = yield post("/admin/calendar/menu-item", params)
    yield put(updateCalendarEventsSuccess(response))
    yield put(hideSavingModal())
  } catch (error) {
    yield put(updateCalendarEventsFailed(error))
  }
}

function* getCalendarReports({ payload: params }) {
  try {
    const response = yield get("/admin/calendar/reports", { params })
    yield put(getCalendarReportsSuccess(response))
  } catch (error) {
    yield put(getCalendarReportsFailed(error))
  }
}

function* calendarEventsSaga() {
  yield takeEvery(GET_CALENDAR_EVENTS, getCalendarEvents)
  yield takeEvery(GET_CALENDAR_EVENT_FEATURE, getCalendarEventsFeature)
  yield takeEvery(UPDATE_CALENDAR_EVENTS, updateCalendarEvents)
  yield takeEvery(GET_CALENDAR_REPORTS, getCalendarReports)
}

export default calendarEventsSaga
